// export the components
import ShareButtonExported from './ShareButton';
import CardInfoExported from './CardInfo';
import ProductPanelExported from './ProductPanel';
import ArticleExported from './Article';
import FormGroupExported from './FormGroup';
import BtnConfirmExported from './BtnConfirm';
import BtnInquiryExported from './BtnInquiry';
import ButtonExported from './Button';
import TextInputExported from './Input';
import TextAutoCompleteInputExported from './AutoCompleteInput';
import CheckBoxExported from './CheckBox';
import CheckBoxMultipleExported from './CheckBoxMultiple';
import TooltipExported from './Tooltip';
import DropdownExported from './Dropdown';
import DropdownGeolocationExported from './DropdownGeolocation';
import InputExported from './Input';
import TagExported from './Tag';
import TextExported from './Text';
import ModalExported from './Modal';
import ModalMobileExported from './ModalMobile';
import ModalShareExported from './ModalShare';
import CarouselExported from './Carousel';
import CardExported from './Card';
import AccordionExported from './Accordion';
import AccordionNewCarExported from './AccordionNewCar';
import PaginationExported from './Pagination';
import StaticPaginationExported from './StaticPagination';
import TabsExported from './Tabs';
import CountdownTimerExported from './CountdownTimer';
import BtnContactUsExported from './BtnContactUs';
import BtnLoginSignupExported from './BtnLoginSignup';
import ToogleSwitchExported from './Toggle';
import OtpInputExported from './OtpInput';
import GeoPositionExported from './GeoPosition';
import TanyaTasiaExported from './TanyaTasia';
import ColorCheckboxExported from './ColorCheckbox';
import RangeSliderExported from './RangeSlider';
import TabsPromoExported from './TabsPromo';
import StructuredDataExported from './StructuredData';
import MetadataExported from './Metadata';
import TextAreaExported from './TextArea';
import AccordionSpesificationNewCarPurchaseExported from './AccordionSpesificationNewCarPurchase';
import ButtonMovePageExported from './ButtonMovePage';
import BadgeExported from './Badge';
import ImageWithLoaderExported from './ImageWithLoader';
import LoadingAnimationExported from './LoadingAnimation';
import AnimationExported from './Animation';
import AccordionCMSExported from './AccordionCMS';
import SidebarDrawerExported from './SidebarDrawer';
import SimpleStepBarExported from './SimpleStepBar';
import FilterSearchNewCarExported from './FilterSearchNewCar';
import ScrollDownButtonExported from './ScrollDownButton';
import DropzoneExported from './Dropzone';
import SortModalContentExported from './SortModalContent';
import FilterModalContentExported from './FilterModalContent';
import CloseIconModalCMSExported from './CloseIconModalCMS';
import CardRefComparasionExported from './CardRefComparasion';
import ServicesDetailTableExported from './ServicesDetailTable';
import TermsConditionServicesExported from './TermsConditionServices';
import TermsModalContentExported from './TermsModalContent';
import PackageCarModalExported from './PackageCarModal';
import TypeCarModalExported from './TypeCarModal';
import ModalCheckoutServicesExported from './ModalCheckoutServices';
import DiscountTagExported from './DiscountTag';
import DividerExported from './Divider';
import VoucherCardExported from './VoucherCard';
import FilterModalContentServicePackagesExported from './FilterModalContentServicePackages';
import ServiceCouponDetailExported from './ServiceCouponDetail';
import CounterExported from './Counter';
import ShowMoreContentExported from './ShowMoreContent';
import TabsOrderExported from './TabsOrder';
import VerticalStepBarExported from './VerticalStepBar';
import CarouselBlackArrowExported from './CarouselBlackArrow';
import StarRateExported from './StarRate';
import ToogleButtonExported from './ToogleButton';
import CarGalleryExported from './CarGallery';
import ToastExported from './Toast';
import CustomCarousel from './CustomCarousel';
import DatePickerExported from './DatePicker';
import CustomMultiSelectExported from './CustomMultiSelect';
import CascaderDropdown from './CascaderDropdown';
import DisclaimerTextExported from './DisclaimerText';
import ModalMobileNativeScrollExported from './ModalMobileNativeScroll';
import FilterModalTrackingTransactionExported from './FilterModalTrackingTransaction';
import BtnCopyTextExported from './BtnCopyText';
import InputModalMobileExported from './InputModalMobile';
import ListCheckBoxExported from './ListCheckBox';
import InputSearchCheckBoxExported from './InputSearchCheckBox';
import SelectionCheckBoxExported from './SelectionCheckBox';
import FilterModalContentAccessoriesExported from './FilterModalContentAccessories';
import RadioExported from './Radio';
import TermsModalContentServicesExported from './TermsModalContentServices';
import DropSelectExported from './DropSelect';
import DropSelectCarTypeExported from './DropSelectCarType';
import InputFieldExported from './InputField';

export const ShareButton = ShareButtonExported;
export const CardInfo = CardInfoExported;
export const ProductPanel = ProductPanelExported;
export const Article = ArticleExported;
export const FormGroup = FormGroupExported;
export const BtnConfirm = BtnConfirmExported;
export const BtnInquiry = BtnInquiryExported;
export const Button = ButtonExported;
export const TextInput = TextInputExported;
export const TextAutoCompleteInput = TextAutoCompleteInputExported;
export const CheckBox = CheckBoxExported;
export const CheckBoxMultiple = CheckBoxMultipleExported;
export const Tooltip = TooltipExported;
export const Dropdown = DropdownExported;
export const DropdownGeolocation = DropdownGeolocationExported;
export const Input = InputExported;
export const Tag = TagExported;
export const Text = TextExported;
export const Modal = ModalExported;
export const ModalMobile = ModalMobileExported;
export const ModalShare = ModalShareExported;
export const Carousel = CarouselExported;
export const Card = CardExported;
export const Accordion = AccordionExported;
export const AccordionNewCar = AccordionNewCarExported;
export const Pagination = PaginationExported;
export const StaticPagination = StaticPaginationExported;
export const Tabs = TabsExported;
export const CountdownTimer = CountdownTimerExported;
export const BtnContactUs = BtnContactUsExported;
export const BtnLoginSignup = BtnLoginSignupExported;
export const ToogleSwitch = ToogleSwitchExported;
export const OtpInput = OtpInputExported;
export const GeoPosition = GeoPositionExported;
export const TanyaTasia = TanyaTasiaExported;
export const ColorCheckbox = ColorCheckboxExported;
export const RangeSlider = RangeSliderExported;
export const TabsPromo = TabsPromoExported;
export const StructuredData = StructuredDataExported;
export const Metadata = MetadataExported;
export const TextArea = TextAreaExported;
export const AccordionSpesificationNewCarPurchase = AccordionSpesificationNewCarPurchaseExported;
export const ButtonMovePage = ButtonMovePageExported;
export const Badge = BadgeExported;
export const ImageWithLoader = ImageWithLoaderExported;
export const LoadingAnimation = LoadingAnimationExported;
export const Animation = AnimationExported;
export const AccordionCMS = AccordionCMSExported;
export const SidebarDrawer = SidebarDrawerExported;
export const SimpleStepBar = SimpleStepBarExported;
export const FilterSearchNewCar = FilterSearchNewCarExported;
export const ScrollDownButton = ScrollDownButtonExported;
export const Dropzone = DropzoneExported;
export const SortModalContent = SortModalContentExported;
export const FilterModalContent = FilterModalContentExported;
export const CloseIconModalCMS = CloseIconModalCMSExported;
export const CardRefComparasion = CardRefComparasionExported;
export const ServicesDetailTable = ServicesDetailTableExported;
export const TermsConditionServices = TermsConditionServicesExported;
export const TermsModalContent = TermsModalContentExported;
export const PackageCarModal = PackageCarModalExported;
export const TypeCarModal = TypeCarModalExported;
export const ModalCheckoutServices = ModalCheckoutServicesExported;
export const DiscountTag = DiscountTagExported;
export const Divider = DividerExported;
export const VoucherCard = VoucherCardExported;
export const FilterModalContentServicePackages = FilterModalContentServicePackagesExported;
export const ServiceCouponDetail = ServiceCouponDetailExported;
export const Counter = CounterExported;
export const ShowMoreContent = ShowMoreContentExported;
export const TabsOrder = TabsOrderExported;
export const VerticalStepBar = VerticalStepBarExported;
export const CarouselBlackArrow = CarouselBlackArrowExported;
export const StarRate = StarRateExported;
export const ToogleButton = ToogleButtonExported;
export const CarGallery = CarGalleryExported;
export const Toast = ToastExported;
export const OwnCarousel = CustomCarousel;
export const DatePicker = DatePickerExported;
export const CustomMultiSelect = CustomMultiSelectExported;
export const EnhanceDropdown = CascaderDropdown;
export const DisclaimerText = DisclaimerTextExported;
export const ModalMobileNativeScroll = ModalMobileNativeScrollExported;
export const FilterModalTrackingTransaction = FilterModalTrackingTransactionExported;
export const BtnCopyText = BtnCopyTextExported;
export const InputModalMobile = InputModalMobileExported;
export const ListCheckBox = ListCheckBoxExported;
export const InputSearchCheckBox = InputSearchCheckBoxExported;
export const SelectionCheckBox = SelectionCheckBoxExported;
export const FilterModalContentAccessories = FilterModalContentAccessoriesExported;
export const Radio = RadioExported;
export const TermsModalContentServices = TermsModalContentServicesExported;
export const DropSelect = DropSelectExported;
export const DropSelectCarType = DropSelectCarTypeExported;
export const InputField = InputFieldExported;
